'use client';

import getConfig from 'next/config';
import { decodeIdToken } from '../getters/auth';
import { useRestQueryRequest } from './use-request';
import { useAuth0User } from './useAuth0User';
import { useAuthToken } from './useAuthToken';
export default function useUserDetails(isBusinessBooker, isLoggedIn, userDetails) {
  var _ref = getConfig() || {},
    _ref$publicRuntimeCon = _ref.publicRuntimeConfig,
    publicRuntimeConfig = _ref$publicRuntimeCon === void 0 ? {} : _ref$publicRuntimeCon;
  var _useAuthToken = useAuthToken(),
    authToken = _useAuthToken.token,
    isAuth0Enabled = _useAuthToken.isAuth0Enabled,
    isAuthTokenLoading = _useAuthToken.isLoading;
  var _useAuth0User = useAuth0User(isAuth0Enabled),
    auth0User = _useAuth0User.user;
  var email = isAuth0Enabled && auth0User !== null && auth0User !== void 0 && auth0User.email ? auth0User.email : decodeIdToken(authToken).email;
  var _useRestQueryRequest = useRestQueryRequest(['userDetails', authToken], 'GET', "".concat(publicRuntimeConfig.NEXT_PUBLIC_REST_API, "/customers/hotels/").concat(email, "?business=").concat(isBusinessBooker), authToken ? {
      Authorization: "Bearer ".concat(authToken)
    } : undefined, {
      enabled: isLoggedIn && !isAuthTokenLoading && !!authToken && !!email && !userDetails
    }),
    data = _useRestQueryRequest.data;
  return userDetails !== null && userDetails !== void 0 ? userDetails : data;
}